import Swal from 'sweetalert2';
export const endpoint = 'https://backend.acsaintjohns.org';
/**
 *
 * @param {string} endpoint
 * @param {string} direction
 * @param {string} method
 * @param {Object} body
 * @returns {Promise<Object>} Respuesta en formato JSON
 */
export const connectionData = async (endpoint, direction, method, body = null) => {
  try {
    const requestOptions = {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };
    if (body) {
      requestOptions.body = JSON.stringify(body);
    }
    const response = await fetch(`${endpoint}/${direction}`, requestOptions);
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    if (method === 'POST' || method === 'PUT' && direction !== 'alumnos/tomakeaverageoralall' && direction!== 'alumnos/tomakeaveragegeneral') {
      Swal.fire({
        icon: 'success',
        title: 'Realizado!',
        text: 'La operación se completó correctamente.',
        confirmButtonText: 'Listo!'
      });
    } else if (method === 'DELETE') {
      Swal.fire({
        icon: 'success',
        title: 'Eliminado!',
        text: 'El registro se eliminó correctamente.',
        confirmButtonText: 'Listo!'
      });
    }
    return await response.json();
  } catch (error) {
    console.error('Ha ocurrido un error con la API:', error.message);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.message,
      confirmButtonText: 'Aceptar'
    });
  }
};
